import { ERP } from '../_base/endpoint';
import axios from 'axios';

class guiaService {

    /******* QUERIES ******/
    
    async listar() {
        const response = await axios
            .get(`${ERP}guia/servicio`)
            .then(response => {
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

}

export default new guiaService();